module.exports = __webpack_public_path__ + "static/media/Temple.ad1cdf65.png";